export default __webpack_public_path__ + "static/media/curtain.c33e9435.png";